import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { enableUSer, get, post, searchData } from "../../services/Service";
import { GroupList, Group_Disable, Group_Enable, Users } from "../../services/Url";
import moment from "moment";
import { Loader } from "../../Components/Loader";


export default function GroupTable() {
  const [checked, setChecked] = useState(true);
  const [data, setData] = useState([]);
  const [user, setUser] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  let pageData = JSON.stringify({
    search_string: searchText,
    page: page,
  });

  useEffect(() => {
    post(GroupList, pageData, setData, setIsloading);
  }, [page]);

  useEffect(() => {
    searchData(GroupList, pageData, setData);
  }, [searchText]);

  const pagingHandler = (event, value) => {
    setPage(value);
    let pageData = {
      search_string: searchText,
      page: value,
    };
    pageData = JSON.stringify(pageData);
    post(GroupList, pageData, setData, setIsloading);
  };

  const enableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(Group_Enable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      post(GroupList, pageData, setData, setIsloading);
    }, 1500);
  };

  const disableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(Group_Disable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      post(GroupList, pageData, setData, setIsloading);
    }, 1500);
  };

  const firstDrawsConstants = {
    "First Draw +1": "Keep First Draw",
    "First Draw": "Hold First Draw",
  }


  const tableData = () => {
    return (
      <TableContainer className="tbl_mn br-24 br-btm-0 ">
        <Box className="table-responsive">
          <Table className="table-design table_center">
            <TableHead>
              <TableRow className="tbl_rw">
                <TableCell className="fz-18 fw-bold">Group Name</TableCell>
                <TableCell className="fz-18 fw-bold">Owner Name</TableCell>
                <TableCell className="fz-18 fw-bold">
                  Members Count
                </TableCell>
                <TableCell className="fz-18 fw-bold">
                  Group Created Date
                </TableCell>
                <TableCell className="fz-18 fw-bold">Start Date</TableCell>
                <TableCell className="fz-18 fw-bold">End Date</TableCell>
                <TableCell className="fz-18 fw-bold">Recovery Method</TableCell>
                <TableCell className="fz-18 fw-bold">Bankers Fees</TableCell>
                <TableCell className="fz-18 fw-bold">Block/ Unblock</TableCell>
                <TableCell className="fz-18 fw-bold">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {data?.docs?.length > 0 ?
                data?.docs?.map((item, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell className="fz-16" scope="row">
                        {item.group_name}
                      </TableCell>
                      <TableCell className="fz-16">
                        {item.created_by?.first_name}{" "}
                        {item.created_by?.last_name}
                      </TableCell>
                      <TableCell className="fz-16">
                        {[...new Set(item.participants)].length}
                      </TableCell>

                      <TableCell className="fz-16">
                        {moment(item.createdAt).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell className="fz-16">
                        {moment(item.start_date).format("DD-MM-YYYY")}
                      </TableCell>

                      <TableCell className="fz-16">

                        {item?.end_date
                          ? moment(item.end_date).format("DD-MM-YYYY")
                          : ""}
                        {/* {moment(item.end_date).format("DD-MM-YYYY")} */}
                      </TableCell>
                      <TableCell className="fz-16">
                        {firstDrawsConstants[item.loss_recovery] || item.loss_recovery}
                      </TableCell>
                      <TableCell className="fz-16">
                        {firstDrawsConstants[item?.bankers_fees] || item?.bankers_fees}
                      </TableCell>

                      <TableCell
                        className="fz-16"
                        style={{ textAlign: "center" }}
                      >
                        <Switch
                          checked={item.status}
                          onChange={() =>
                            item.status
                              ? disableUserHandler(item?._id)
                              : enableUserHandler(item?._id)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </TableCell>

                      <TableCell className="fz-16">
                        <Link to={`/editgroup/${item._id}`} style={{ marginRight: "8px" }}><EditIcon /></Link>
                        <Link to={`/groupdetail/${item._id}`}>
                          <RemoveRedEyeIcon />
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                }) :
                <TableRow>
                  <TableCell colSpan={12} className="empty-text">
                    No data found
                  </TableCell>
                </TableRow>
              }

            </TableBody>
          </Table>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          {data?.docs?.length > 0 ?
            <Stack spacing={2}>
              <Pagination count={data?.totalPages} onChange={pagingHandler} />
            </Stack> : ''}
        </Box>
      </TableContainer>
    );
  };

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="start"
    >
      {isloading ? <Loader /> : ''}
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">Groups Management</h5>
        <Box className="table_srch">
          <TextField
            placeholder="Search Group here"
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Box>
      </div>
      {tableData()}
    </Box>
  );
}
